/** Custom Vuetify color theme */
export default {
	primary: '#255EA7',
	secondary: '#003763',
	accent: '#1976dc',
	error: '#e54d42',
	info: '#0077c5',
	success: '#009688',
	warning: '#977000'
};
